import { render, staticRenderFns } from "./MunicipalityParent.vue?vue&type=template&id=9b478234&"
import script from "./MunicipalityParent.vue?vue&type=script&lang=js&"
export * from "./MunicipalityParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports